var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenAudioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 12.3301C20.3125 11.5879 19.7249 10.9863 19 10.9863C18.2751 10.9863 17.6875 11.5879 17.6875 12.3301V26.6634C17.6875 27.4055 18.2751 28.0072 19 28.0072C19.7249 28.0072 20.3125 27.4055 20.3125 26.6634V12.3301Z",
    fill: "#5FAC8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 14.1217C15.0625 13.3796 14.4749 12.778 13.75 12.778C13.0251 12.778 12.4375 13.3796 12.4375 14.1217L12.4375 24.8717C12.4375 25.6139 13.0251 26.2155 13.75 26.2155C14.4749 26.2155 15.0625 25.6139 15.0625 24.8717V14.1217Z",
    fill: "#5FAC8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5625 14.1217C25.5625 13.3796 24.9749 12.778 24.25 12.778C23.5251 12.778 22.9375 13.3796 22.9375 14.1217V24.8717C22.9375 25.6139 23.5251 26.2155 24.25 26.2155C24.9749 26.2155 25.5625 25.6139 25.5625 24.8717V14.1217Z",
    fill: "#5FAC8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 17.7051C9.8125 16.9629 9.22487 16.3613 8.5 16.3613C7.77513 16.3613 7.1875 16.9629 7.1875 17.7051V21.2884C7.1875 22.0305 7.77513 22.6322 8.5 22.6322C9.22487 22.6322 9.8125 22.0305 9.8125 21.2884V17.7051Z",
    fill: "#5FAC8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8125 17.7051C30.8125 16.9629 30.2249 16.3613 29.5 16.3613C28.7751 16.3613 28.1875 16.9629 28.1875 17.7051V21.2884C28.1875 22.0305 28.7751 22.6322 29.5 22.6322C30.2249 22.6322 30.8125 22.0305 30.8125 21.2884V17.7051Z",
    fill: "#5FAC8A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0.236328C8.61014 0.236328 0.1875 8.85951 0.1875 19.4967C0.1875 30.134 8.61014 38.7572 19 38.7572C29.3899 38.7572 37.8125 30.134 37.8125 19.4967C37.8125 8.85951 29.3899 0.236328 19 0.236328ZM2.8125 19.4967C2.8125 10.3438 10.0599 2.92383 19 2.92383C27.9401 2.92383 35.1875 10.3438 35.1875 19.4967C35.1875 28.6497 27.9401 36.0697 19 36.0697C10.0599 36.0697 2.8125 28.6497 2.8125 19.4967Z",
    fill: "#5FAC8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAudioIcon);
export default __webpack_public_path__ + "static/media/greenAudioIcon.183a50bc0bdae7c320a2f5f793429d75.svg";
export { ForwardRef as ReactComponent };